import React from 'react';
import { useSelector } from 'react-redux';
// ##### 25-05-21 Komarov
import HomeIcon from '../Icons/homeicon';
import LocalizationNavLink from '../Localization/LocalizationNavLink';
// ##### 23-11-01 Komarov
import parse from 'html-react-parser';
import { Media } from '../../../helpers/MediaConfig';

// ##### Komarov 2025-07-14
const HomeLinkTag = () => {
  const deviceType = useSelector(state => state.deviceType);
  // ##### Komarov 2025-08-05
  const hintText = useSelector(state => state.pagesRedux[state.language]?.Home_icon || '');

  return (
    <LocalizationNavLink exact to={''}>
      {
        // ##### 23-04-24 Komarov
        deviceType === 'tablet' ? (
          <HomeIcon hintText={parse(hintText)} />
        ) : (
          <>
            {/* ##### 25-01-16 Komarov */}
            <Media
              greaterThanOrEqual="Laptop-1024-1440"
              style={{
                position: 'relative',
                zIndex: 2001,
              }}
            >
              <HomeIcon hintText={parse(hintText)} />
            </Media>
            <Media lessThan="Laptop-1024-1440">
              <HomeIcon hintText={parse(hintText)} />
            </Media>
          </>
        )
      }
    </LocalizationNavLink>
  );
};

// ##### 25-05-21 Komarov
export default HomeLinkTag;
